import { AvailabilityControllerApi, AvailabilitySetting } from "../services";
import { getConfigObject, useMutationWithLoading } from "../utils/utils";

/**
 *
 * @author Shrinivas Mandhare
 */
export const useEditAvailability = () =>
  useMutationWithLoading(
    async (params: AvailabilitySetting & { xTENANTID?: string }) =>
      new AvailabilityControllerApi(
        getConfigObject()
      ).setProviderAvailabilitySetting(params, params.xTENANTID)
  );
